import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/hooks/useAuth';

import { fetchCategories, type FetchCategoriesResponse } from '@/services/claims';

export function useCategories() {
  const { user } = useAuth();

  const { data, isLoading, error, refetch } = useQuery<FetchCategoriesResponse, Error>({
    queryKey: ['categories'],
    queryFn: fetchCategories,
    enabled: !!user,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return {
    data: data?.items ?? [],
    loading: isLoading,
    error: error?.message ?? null,
    refetch,
  };
}
